<template>
  <header class="flex fixed w-full h-[100vh] py-[20px] h-[90px] bg-[#191414]">
    <div class="w-full justify-evenly items-center md:flex hidden">
      <div class="justify-evenly items-center flex w-full">
<!--        <div class="w-[60%] h-[2px] bg-white absolute top-0 translate-x-[-200vh] duration-[500ms]" :class="{'!translate-x-0' : !showLines}" />-->
        <div><h3 @click="scrollToView($refs.begin)" class="cursor-pointer">{{ $t('header.introduction') }}</h3></div>
        <div><h3 @click="scrollToView($refs.about)" class="cursor-pointer">{{ $t('header.about') }}</h3></div>
        <div><h3 @click="scrollToView($refs.author)" class="cursor-pointer">{{ $t('header.author') }}</h3></div>
        <div class="w-[calc(40%+8%)] mr-[-8%] h-[1px] bg-white absolute bottom-0 translate-x-[-500vh] duration-[500ms]" :class="{'!translate-x-0' : !showLines}"/>
      </div>
      <div @click="scrollTop()" class="w-[160px] h-full cursor-pointer"/>
      <div class="justify-evenly items-center flex w-full">
<!--        <div class="w-[60%] h-[2px] bg-white absolute top-0 translate-x-[200vh] duration-[500ms]" :class="{'!translate-x-0' : !showLines}" />-->
        <div><h3 @click="scrollToView($refs.contact)" class="cursor-pointer">{{ $t('header.contact') }}</h3></div>
        <div><h3 @click="scrollToView($refs.support)" class="cursor-pointer">{{ $t('header.support') }}</h3></div>
        <div class="locale-changer">
          <div class="flex flex-row justify-between items-center gap-[10px]">
            <h3 @click="$i18n.locale = 'sk'" class="cursor-pointer" :class="$i18n.locale === 'sk' ? '!text-[#488DC0]' : 'text-white'">SK</h3>
            <div class="w-min-[2px] w-[2px] h-[25px] mt-[5px] bg-white" />
            <h3 @click="$i18n.locale = 'en'" class="cursor-pointer" :class="$i18n.locale === 'en' ? '!text-[#488DC0]' : 'text-white'">EN</h3>
          </div>
        </div>
        <div class="w-[calc(40%+8%)] ml-[-8%] h-[1px] bg-white absolute bottom-0 translate-x-[500vh] duration-[500ms]" :class="{'!translate-x-0' : !showLines}" />
      </div>
    </div>
    <div class="w-full h-[100vh] flex justify-center absolute pointer-events-none">
      <img :src="require('@/assets/logo.svg')" class="md:w-[20%] w-[70%] min-h-[50px]" alt="main logo" :style="`${getScale};`" ref="logo"/>
    </div>
    <div class="w-full flex items-center justify-end md:hidden">
      <svg fill="white" xmlns="http://www.w3.org/2000/svg" @click="isOpen = !isOpen" class="mr-[20px] z-[50]" viewBox="0 0 50 50" width="25px" height="25px">
        <path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"/></svg>
      <div class="w-[200%] h-[1px] bg-white absolute bottom-0 translate-x-[500vh] duration-[500ms]" :class="{'!translate-x-0' : !showLines}" />
    </div>
    <div class="w-full h-[100vh] bg-[#191414] md:hidden absolute translate-y-[-100vh] duration-[200ms] z-[20]" :class="{'!translate-y-0' : isOpen}">
      <div class="w-full h-[100vh] flex justify-center absolute pointer-events-none">
        <img :src="require('@/assets/logo.svg')" class="md:w-[20%] w-[70%] h-[50px]" alt="main logo" ref="logo"/>
      </div>
      <div class="flex flex-col items-center justify-evenly mt-[100px] h-[60%]">
        <h3 @click="scrollToView($refs.begin)">{{ $t('header.introduction') }}</h3>
        <h3 @click="scrollToView($refs.about)">{{ $t('header.about') }}</h3>
        <h3 @click="scrollToView($refs.author)">{{ $t('header.author') }}</h3>
        <h3 @click="scrollToView($refs.contact)">{{ $t('header.contact') }}</h3>
        <h3 @click="scrollToView($refs.support)">{{ $t('header.support') }}</h3>
        <!-- <h3 @click="scrollToView($refs.sponsors)" class="pointer">Sponzori</h3> -->
        <div class="locale-changer">
          <div class="flex flex-row justify-center items-center gap-[20px] mt-[20px]">
            <h3 @click="$i18n.locale = 'sk'" class="cursor-pointer" :class="$i18n.locale === 'sk' ? '!text-[#488DC0]' : 'text-white'">SK</h3>
            <div class="w-min-[2px] w-[2px] h-[40px] bg-white mt-[15px]" />
            <h3 @click="$i18n.locale = 'en'" class="cursor-pointer" :class="$i18n.locale === 'en' ? '!text-[#488DC0]' : 'text-white'">EN</h3>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div class="min-h-[100vh] flex justify-center items-center">
<!--    <img :src="require('@/assets/logo.svg')" class="md:w-[20%] w-[70%]" alt="main logo"/>-->
  </div>

  <div class="max-width md:pt-[80px] pt-[80px] flex flex-col justify-center items-center mt-[30px]" ref="begin">
    <h1>{{ $t('introduction.title') }}</h1>
    <p>{{ $t('introduction.text') }}</p>
  </div>
  <div class="max-width md:!pt-[40px] pt-[20px] md:pt-0 flex flex-col justify-center items-center mt-[30px]" ref="about">
    <h1>{{ $t('about.title') }}</h1>
    <p class="whitespace-pre-line">{{ $t('about.text') }}</p>
  </div>

  <div class="md:p-0 p-[20px] md:my-[80px] flex justify-center gap-[50px] flex-wrap">
    <img :src="require('@/assets/obr_1.png')" class="image" alt="3D model of corset"/>
    <img :src="require('@/assets/obr_2.png')" class="image" alt="3D model of corset"/>
    <img :src="require('@/assets/obr_4.png')" class="image" alt="3D model of corset"/>
    <img :src="require('@/assets/obr_3.png')" class="image" alt="3D model of corset"/>
  </div>

  <div class="max-width min-h-[70vh] py-[20px] md:flex justify-center items-center mt-[50px]" ref="author">
    <h1 class="md:hidden text-left">{{ $t('author.title') }}</h1>
    <h2 class="md:hidden text-left">{{ $t('author.name') }}</h2>

    <div class="md:w-1/3">
      <img :src="require('@/assets/about.jpg')" class="md:w-[90%] mb-[20px]" alt="author"/>
    </div>
    <div class="md:w-2/3">
      <h1 class="hidden md:block">{{ $t('author.title') }}</h1>
      <h2 class="hidden md:block !text-left">{{ $t('author.name') }}</h2>
      <p>{{ $t('author.text') }}</p>
    </div>
  </div>

  <div class="max-width md:pt-[40px] pt-[20px]" ref="contact">
    <h1>{{ $t('contact.title') }}</h1>
    <div class="flex justify-between flex-wrap md:mt-[80px]">
      <a :href="'tel:' + $t('contact.phone')" class="contact-item">
        <svg fill="white" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
        <p>{{ $t('contact.phone') }}</p>
      </a>
      <a href="mailto:ortho3d@arttege.eu" class="contact-item">
        <svg fill="white" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
        <p>ortho3d@arttege.eu</p>
      </a>
      <a :href="$t('contact.instagram.link')" class="contact-item">
        <svg fill="white" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3Z"/></svg>
        <p>{{ $t('contact.instagram.text') }}</p>
      </a>
    </div>
  </div>

  <div class="max-width md:pt-[40px] pt-[20px] mb-[100px]" ref="support">
    <h1 class="text-left">{{ $t('support.title') }}</h1>
    <div class="flex flex-col md:flex-row justify-center items-center md:mt-[80px]">
      <div class="md:w-1/4 flex justify-center">
        <img :src="require('@/assets/qrcode.svg')" class="w-[70%]" alt="author"/>
      </div>
      <div class="md:w-2/3 flex flex-col items-center">
        <h2 class="md:!text-[28px]">IBAN: {{ $t('support.iban') }}</h2>
        <p class="text-center md:!text-[20px]"><b>{{ $t('support.account.title') }}:</b> {{ $t('support.account.name') }} <b>{{ $t('support.address.title') }}:</b> {{ $t('support.address.name') }}</p>
        <p class="text-center md:!text-[20px]"><b>{{ $t('support.bank.title') }}:</b> {{ $t('support.bank.name') }} <b>{{ $t('support.swift.title') }}:</b> {{ $t('support.swift.code') }}</p>
      </div>
    </div>
  </div>

  <!-- <div class="max-width md:pt-[40px] pt-[20px] mb-[50px]" ref="sponsors">
    <h1>Sponzori projektu</h1>
    <div class="flex flex-col items-start gap-[40px] md:mt-[80px]">
      <img :src="require('@/assets/tuke_logo_1.svg')" class="md:h-[80px] h-[35px]" alt="author"/>
      <img :src="require('@/assets/tuke_logo_2.svg')" class="md:h-[80px] h-[35px]" alt="author"/>
    </div>
  </div> -->

</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      scrollValue: 0,
      isOpen: false,
      showLines: true
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener)
  },
  unmounted() {
    window.removeEventListener("scroll", this.scrollListener)
  },
  watch: {
    'isOpen': {
      handler() {
        console.log(this.isOpen)
      }
    }
  },
  methods: {
    scrollListener() {
      this.scrollValue = window.scrollY
      const decrease = window.innerWidth > 768 ? 120 : 70
      this.showLines = this.$refs.begin.offsetTop - decrease > window.scrollY;
      this.$refs.logo.style.width = `calc(100%-${window.scrollY};`
    },
    scrollToView(ref, offset) {
      const headerOffset = offset ? offset : 80;
      const elementPosition = ref.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
      // ref.scrollIntoView({behavior: 'smooth', block: 'start'})
      this.isOpen = false
    },
    scrollTop() {
      window.scrollTo({top: 0, behavior: "smooth"})
    }
  },
  computed: {
    getScale() {
      return `height: calc(100% - ${this.scrollValue}px);`
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: 600;
  /*text-decoration: underline;*/
  /*text-decoration-color: #488DC0;*/
  /*text-transform: uppercase;*/
  @apply text-white text-left md:text-[50px] text-[32px] mb-[20px] w-full
}

h2 {
  font-weight: 600;
  @apply text-[#488DC0] text-center md:text-[45px] text-[27px] mt-[30px] mb-[20px] w-full
}

h3 {
  font-weight: 600;
  @apply text-white text-center h-[30px] md:text-[22px] text-[32px]
}

h3:hover {
  font-weight: 600;
  @apply text-[#488DC0] text-center h-[30px] md:text-[22px] text-[32px]
}

p {
  @apply text-white md:text-[25px] text-[18px] mb-[20px] text-justify
}

.contact-item {
  @apply flex justify-between items-center
}

.contact-item p {
  overflow-wrap: break-word;
  @apply md:text-[25px] text-[18px]
}

.image {
  @apply md:max-w-[20%]
}

.contact-item svg {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  margin-bottom: 20px;
}
</style>
